import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Updates a Pending Profit Distribution and replaces its cutoffs
export const updateProfitDistribution = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/profit_distribution/updateProfitDistribution`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
